
















import { Component, Vue, Prop } from "vue-property-decorator";
import { Brand, Broadcaster, Company, Product, Circuit } from "@/models";
import LogoWithFallback from "@/components/LogoWithFallback.vue";
import ColorHelper from "@/services/ColorHelper";
import Dictionary from "@/interfaces/Dictionary";

@Component({
  components: {
    LogoWithFallback,
  },
})
export default class EntryItem extends Vue {
  @Prop() readonly item!: Company | Brand | Product | Broadcaster | Circuit;
  @Prop() readonly color?: string | number | undefined;
  @Prop() readonly titleSuffix?: string;
  @Prop() readonly size?: string | undefined;
  @Prop({ default: "center" }) readonly textAlign?: "left" | "center" | "right";

  get brandName() {
    if (this.item.type === "products") {
      return (this.item as Product).brand?.name || "";
    }
    return "";
  }

  get companyName() {
    if (this.item.type === "products") {
      return (this.item as Product).company?.name || "";
    }
    if (this.item.type === "brands") {
      return (this.item as Brand).company?.name || "";
    }
    return "";
  }

  getColor(): string {
    if (typeof this.color == "string") {
      return this.color;
    } else {
      return this.color
        ? ColorHelper.colorAtIndex(this.color)
        : ColorHelper.pickForKey(this.item.id);
    }
  }

  getComponentClass() {
    const klass: Dictionary = {};

    if (this.size != undefined) {
      klass[`entry-item--${this.size}`] = true;
    }

    return klass;
  }

  get sizeClass() {
    switch (this.textAlign) {
      case "left":
        return "text-left";
      case "right":
        return "text-right";
    }
    return "";
  }

  get logoUrls(): string[] {
    return this.item.logoUrls ?? [];
  }

  protected onClick() {
    this.$emit("click");
  }
}
